'use client';
import InformationLamp from '@/components/icons/Action/InformationLamp';
import { FC, ReactNode } from 'react';
import styles from './styles.module.scss';

const InfoTip: FC<{ title?: string; message: ReactNode }> = ({
  title,
  message,
}) => {
  return (
    <div className="flex-column">
      <div className={styles.chevron} />
      <div className={`flex-row gap-s ${styles.tooltip}`}>
        <InformationLamp className={styles.icon} />
        <div className="flex-column gap-xs">
          {title && <p className="s bold">{title}</p>}
          {message}
        </div>
      </div>
    </div>
  );
};

export default InfoTip;
